import { SubmittedFormModel } from "../../../services/api/types/forms/models/SubmittedFormModel";
import AddNoteOrVoid from "ui/molecules/common/AddNoteOrVoid";
import { useModifyAssessmentEntry } from "../hooks/useModifyAssessmentEntry";
import { PermissionsEnums } from "../../../services/api/types/authorisation/enums/PermissionsEnums";
import { FormStatusEnum } from "../../../services/api/types/forms/enums/FormStatusEnums";

interface Props {
  entry: SubmittedFormModel | null;
  onClose: () => void;
}

export default function ModifySubmissionForm({ entry, onClose }: Props) {
  const {
    control,
    submit,
    isSubmitting,
    handleVoidAssessmentEntry,
    isVoidLoading,
  } = useModifyAssessmentEntry(entry, {
    onSuccess: onClose,
  });

  const entryVoided = entry?.status === FormStatusEnum.VOIDED;

  return (
    <AddNoteOrVoid
      control={control}
      onClose={onClose}
      submit={submit}
      isSubmitting={isSubmitting}
      voidItem={handleVoidAssessmentEntry}
      isVoidLoading={isVoidLoading}
      requiredPermission={PermissionsEnums.VOID_FORM_SUBMISSION}
      isItemAlreadyVoided={entryVoided}
    />
  );
}
